/**
 * SeoMetaLoader — Round 49.
 *
 * Injects the Google Search Console HTML-tag verification meta into
 * <head> at runtime, sourced from `/api/public/branding` (admin-editable).
 * Idempotent — safe to render multiple times. Renders nothing to the DOM.
 *
 * DNS TXT verification (Domain property) is handled at the registrar and
 * does not require any front-end action — this component only handles
 * the HTML-tag method.
 */
import { useEffect } from "react";
import api from "@/lib/api";

const META_ID = "gsc-verification";

export default function SeoMetaLoader() {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/public/branding");
        const token = data?.seo?.gsc_verification_token || "";
        if (cancelled || !token || typeof document === "undefined") return;
        // Remove any previous injection
        const existing = document.getElementById(META_ID);
        if (existing) existing.remove();
        const meta = document.createElement("meta");
        meta.id = META_ID;
        meta.name = "google-site-verification";
        meta.content = token;
        document.head.appendChild(meta);
      } catch (_) { /* silent */ }
    })();
    return () => { cancelled = true; };
  }, []);
  return null;
}
